var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teachers"},_vm._l((_vm.teacherArray),function(teacher){return _c('teacher-item',{key:teacher.id,attrs:{"teacher":teacher}})}))}
var staticRenderFns = []

export { render, staticRenderFns }